
import jsPDF from 'jspdf';
import { PDF_STYLES } from './pdfStyles';
import { PDFReportData } from '@/types/pdf';
import { formatCurrency } from '../formatters';

export const addReportSummary = (pdf: jsPDF, data: PDFReportData, yPosition: number): number => {
  const { margin, fonts } = PDF_STYLES;
  const leftColumnX = margin;
  const rightColumnX = 105;
  const startY = yPosition;
  
  // Count unique book titles
  const uniqueBookTitles = new Set(
    data.reports
      .map(report => report.books?.title)
      .filter(title => title)
  );
  const bookCount = uniqueBookTitles.size;
  
  // Calculate total previous royalty income (using netSales field)
  const totalPreviousRoyaltyIncome = data.reports.reduce((sum, r) => sum + (r.netSales || 0), 0);
  
  // Calculate total royalty amount using new formula
  const totalRoyaltyAmount = data.reports.reduce((sum, r) => sum + (r.royaltyAmount || r.amount || 0), 0);
  
  // Report Information (Left Column)
  pdf.setFontSize(fonts.subtitle);
  pdf.setFont(undefined, 'bold');
  pdf.text('Report Information', leftColumnX, yPosition);
  yPosition += 8;
  
  pdf.setFontSize(fonts.normal);
  pdf.setFont(undefined, 'normal');
  pdf.text(`Report Period: Q${data.quarter} ${data.year}`, leftColumnX, yPosition);
  yPosition += 5;
  pdf.text(`Report Date: ${new Date().toLocaleDateString()}`, leftColumnX, yPosition);
  yPosition += 5;
  pdf.text(`Status: Published`, leftColumnX, yPosition);
  
  // Quarter Summary (Right Column)
  yPosition = startY;
  pdf.setFontSize(fonts.subtitle);
  pdf.setFont(undefined, 'bold');
  pdf.text('Quarter Summary', rightColumnX, yPosition);
  yPosition += 8;
  
  pdf.setFontSize(fonts.normal);
  pdf.setFont(undefined, 'normal');
  pdf.text(`Total Books: ${bookCount}`, rightColumnX, yPosition);
  yPosition += 5;
  pdf.text(`Total Units Sold: ${data.totalUnitsSold}`, rightColumnX, yPosition);
  yPosition += 5;
  pdf.text(`Total Amount: ${formatCurrency(totalRoyaltyAmount)}`, rightColumnX, yPosition);
  
  return yPosition + 18;
};
